(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfSaveApplication', ['ngDialog', '$timeout', 'thfValidateItems', 'MembershipModel', function (ngDialog, $timeout, thfValidateItems, MembershipModel) {

        var link = function (scope, elem) {
            scope.validationRulesSave = {};
            scope.modelSave = {};
            scope.fieldSave = {
                firstName: {
                    'label': 'First Name',
                    'labelStyle': '',
                    'name': 'firstName',
                    'defaultValue': '',
                    'placeholder': '',
                    'tooltip': '',
                    'maxLength': 16,
                    'validation': [
                        'required'
                    ]
                },
                lastName: {
                    'label': 'Last Name',
                    'labelStyle': '',
                    'name': 'lastName',
                    'defaultValue': '',
                    'placeholder': '',
                    'tooltip': '',
                    'maxLength': 25,
                    'validation': [
                        'required'
                    ]
                },
                phoneNumber: {
                    'label': 'Phone',
                    'labelStyle': '',
                    'name': 'phoneNumber',
                    'defaultValue': [
                        {
                            'type': 'mobile',
                            'value': ''
                        }
                    ],
                    'placeholder': '',
                    'tooltip': '',
                    'validation': [
                        'required',
                        'requiredPhoneNumber'
                    ]
                },
                email: {
                    'label': 'Email',
                    'labelStyle': '',
                    'name': 'email',
                    'defaultValue': '',
                    'placeholder': '',
                    'tooltip': '',
                    'validation': [
                        'required',
                        'thfEmail',
                        'thfSaveConfirmEmail'
                    ]
                },
                confirmEmail: {
                    'label': 'Confirm Email',
                    'labelStyle': '',
                    'name': 'confirmEmail',
                    'defaultValue': '',
                    'placeholder': '',
                    'tooltip': '',
                    'disablePaste': true,
                    'validation': [
                        'required',
                        'thfEmail',
                        'thfSaveConfirmEmail'
                    ]
                },
                dateOfBirth: {
                    'label': 'Date of Birth',
                    'labelStyle': '',
                    'name': 'dateOfBirth',
                    'defaultValue': '',
                    'placeholder': 'DD/MM/YYYY',
                    'datePickerOptions': {
                        yearRange: '-110nn:-nn',
                        minDate: moment().month(0).subtract('110', 'years').toDate(),
                        maxDate: moment().toDate(),
                        defaultDate: moment().format('DD/MM/YYYY')
                    },
                    'tooltip': '',
                    'validation': [
                        'required',
                        'thfDateOfBirth',
                        'thfSaveMatchDOB'
                    ]
                },
                /**
                 * Note when changing the options of this
                 * field, you must also update them in the resume
                 * application partial.
                 *
                 * Also when removing an item please know that
                 * all applications who used that option will no
                 * longer be able to progress with their application.
                 */
                securityQuestion: {
                    'label': 'Security Question',
                    'labelStyle': '',
                    'name': 'securityQuestion',
                    'defaultValue': '',
                    'placeholder': '',
                    'tooltip': '',
                    'validation': [
                        'required'
                    ],
                    'options': [
                        {value: 'mothers_maiden_name', label: 'What is your mother’s maiden name?'},
                        {value: 'favourite_colour', label: 'What is your favourite colour?'},
                        {value: 'first_pet_name', label: 'What was the name of your first pet?'}
                    ]
                },
                securityAnswer: {
                    'label': 'Security Answer',
                    'labelStyle': '',
                    'name': 'securityAnswer',
                    'defaultValue': '',
                    'placeholder': '',
                    'tooltip': '',
                    'validation': [
                        'required',
                        'alphanumeric'
                    ]
                }
            };
            scope.validationSave = {};
            scope.formStateSave = {
                icon: scope.formState.icon,
                tab: 'saveModal'
            };

            for (var k in scope.fieldSave) {
                if (scope.fieldSave.hasOwnProperty(k)) {
                    scope.validationRulesSave[k] = scope.fieldSave[k].validation;
                }
            }

            scope.saveAndCompleteLater = function ($event) {
                $event.preventDefault();
                scope.modelSave.firstName = scope.model.personal.memberFirstName;
                scope.modelSave.lastName = scope.model.personal.memberLastName;
                scope.modelSave.phoneNumber = scope.model.contact.phoneNumber;
                scope.modelSave.email = scope.model.contact.emailAddress;
                scope.modelSave.confirmEmail = '';
                scope.modelSave.dateOfBirth = '';
                scope.modelSave.securityQuestion = '';
                scope.modelSave.securityAnswer = '';
                scope.showSaveModal();

                DSTAPI.track('page', {
                    url: '/join-form/personal-details/save-progress/form-viewed'
                });
            };

            scope.showSavingProgress = function () {
                scope.formState.display.loadingSave = true;
            };

            scope.hideSavingProgress = function () {
                scope.formState.display.loadingSave = false;
            };

            scope.showSaveModal = function () {
                // Set cookie indicating the form is opened
                document.cookie = "formOpened=true; path=/; max-age=3600"; // Expires in 1 hour

                ngDialog.open({
                    template: 'modal-save-application',
                    className: 'ngdialog-theme-plain save-application',
                    controller: ['$scope', function ($scope) {
                        $scope.onClose = function ($event) {
                            var phoneNumbers = $scope.model.contact.phoneNumber;
                            var phoneNumberLength = phoneNumbers.length;
                            if (phoneNumberLength > 1)
                            {
                                for (var i = phoneNumberLength - 1; i >= 1; i--) {
                                    //if (phoneNumbers[i].value === "" || phoneNumbers[i].value === undefined) {
                                        $scope.model.contact.phoneNumber.pop();
                                        //removeNumber();
                                    //}
                                }
                            }
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };

                        function removeNumber() {
                            $timeout(function () {
                                var removeButtons = document.querySelectorAll('a.btn-remove');

                                if (removeButtons.length > 0) {
                                    removeButtons[removeButtons.length - 1].click();
                                }
                            }, 0);
                        };
                        
                        $scope.trackSuccess = () => {
                            var formInstance = document.querySelector('form[name="formEmail"]');
                            window.VWO = window.VWO || [];
                            window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, 1]);
                        }
                        
                        $scope.trackFailure = () => {
                            var formInstance = document.querySelector('form[name="formEmail"]');
                            window.VWO = window.VWO || [];
                            window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, 0]);
                        }

                        function saveSuccess() {
                            $scope.trackSuccess();
                            $scope.hideSavingProgress();
                            $scope.closeThisDialog();
                            $scope.showSaveSuccessModal();
                        }

                        function saveFailure() {
                            $scope.trackFailure();
                            $scope.hideSavingProgress();
                            $scope.showErrorModal('Unable to save', 'Issue Saving, currently unable to save the application.', 'continue');
                        }

                        $scope.onContinue = function ($event) {
                            $event.preventDefault();
                            if (thfValidateItems($scope.validationRulesSave, $scope.fieldSave, $scope.modelSave, $scope.validationSave, $scope.model)) {
                                var memberPassword = '';
                                memberPassword += $scope.modelSave.email + '|';
                                memberPassword += $scope.modelSave.dateOfBirth + '|';
                                memberPassword += $scope.modelSave.securityQuestion + '|';
                                memberPassword += $scope.modelSave.securityAnswer;

                                if ($scope.modelSave.email !== $scope.model.contact.emailAddress) {
                                    $scope.model.contact.emailAddress = $scope.modelSave.email;
                                }

                                $scope.model.personal.memberFirstName = $scope.modelSave.firstName;
                                $scope.model.personal.memberLastName = $scope.modelSave.lastName;
                                $scope.model.contact.phoneNumber = $scope.modelSave.phoneNumber;


                                $scope.showSavingProgress();

                                var currentTab = '';
                                for (var tabName in $scope.tabs) {
                                    if ($scope.tabs.hasOwnProperty(tabName)) {
                                        if($scope.tabs[tabName].active) {
                                            currentTab = tabName;
                                            break;
                                        }
                                    }
                                }

                                if ($scope.formState.applicationId !== null) {

                                    MembershipModel.update($scope.formState.applicationId, $scope.modelSave.email, memberPassword, currentTab, $scope.model)
                                        .then(
                                            function (response) {
                                                saveSuccess();
                                            },
                                            function () {
                                                saveFailure();
                                            }
                                        );
                                }
                                else {
                                    MembershipModel.create(memberPassword, $scope.modelSave.email, currentTab, $scope.model)
                                        .then(
                                            function (response) {
                                                if (response.result) {
                                                    $scope.formState.applicationId = response.content;
                                                    window.history.replaceState({}, null, '?id=' + response.content);
                                                    saveSuccess();

                                                    DSTAPI.track('page', {
                                                        url: '/join-form/personal-details/save-progress/save-successful'
                                                    });
                                                }
                                            },
                                            function () {
                                                saveFailure();
                                            }
                                        );
                                }
                            }
                        };
                    }],
                    scope: scope
                });
            };

            scope.showSaveSuccessModal = function () {
                ngDialog.open({
                    template: 'modal-save-application-success',
                    className: 'ngdialog-theme-plain save-application-success',
                    controller: ['$scope', function ($scope) {
                        $scope.onHomepage = function ($event) {
                            $event.preventDefault();
                            window.location = '/';
                        };

                        $scope.onContinue = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };
                    }],
                    scope: scope
                });
            };
        };

        return {
            'restrict': 'E',
            'replace': true,
            'link': link,
            'templateUrl': function (elem, attr) {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/partials/save-application.html');
            }
        };
    }]);
})(jQuery, angular, window);
